import JsonApi from "../../api/jsonApi";
import {Feature} from "../../interfaces/Feature";
import {AxiosResponse} from "axios";
import {Dispatch} from "redux";
import {RootState} from "../../interfaces/Global";
import {CartItem} from "../../interfaces/CartItem";

let _pricingGrid: PricingGridPreset = {
  columnHeaders: [], priceTable: [], rowHeaders: [], settings: {
    currency: "USD", mode: "RetailPrice", visualizerType: "", version: 1,
  },
};

export const getFeaturesPriceTable = () => {
  return async (dispatch: Dispatch, getState: () => RootState): Promise<any> => {
    if (!getState().fabricatorState.settings.enablePriceGrid) {
      return
    }
    return JsonApi.getFeaturesPriceTable()
      .then((response: AxiosResponse) => {
        if (!response || !Array.isArray(response.data) || !response.data[0] || !response.data[0].priceTable) {
          return
        }
        _pricingGrid = response.data[0];
        console.log("getFeaturesPriceTable _pricingGrid", _pricingGrid);
        // dispatch(restorePaymentInfo(Misc.parseShippingAndBillingResponse({
        //   shippingAddress: response.data,
        // })))
      })
      .catch(error => error)
  }
}

const pricingGridHeaderHasAddedCardItem = (header: PricingGridHeader, storeState: RootState) => {
  return header.featureData.some((featureData: PricingGridHeaderFeature) => {
    return storeState.cartState.cartItems.some((cartItem: CartItem) => {
      return cartItem.cartFeature.dbFeature.sharedFeatureName === featureData.sharedFeatureName
    })
  })
}

export const getPricingGridFeaturePrice = (feature: Feature, storeState: RootState): number | null => {
  if (!storeState.cartState.cartItems.length) {
    return null;
  }
  const existingRecord: PricingGridTableItem = _pricingGrid.priceTable.find(record => {
    return record.sku === feature.dbFeature.sku
  })
  let newPrice: number | null = null;
  if (!existingRecord) {
    return null
  }
  existingRecord.tableData.forEach((tableRow: PricingGridTableItemData) => {
    const columnHeader = _pricingGrid.columnHeaders.find((header: PricingGridHeader) => {
      return header.id === tableRow.columnId;
    });
    const rowHeader = _pricingGrid.rowHeaders.find((header: PricingGridHeader) => {
      return header.id === tableRow.rowId;
    });
    if (!columnHeader || !rowHeader) {
      return null
    }
    if (!pricingGridHeaderHasAddedCardItem(columnHeader, storeState)) {
      return null
    }
    if (!pricingGridHeaderHasAddedCardItem(rowHeader, storeState)) {
      return null
    }
    newPrice = tableRow.price;
  })
  return newPrice;
};
